import { Stack, Typography } from '@mui/material';

export const NO_CATEGORY_LABEL = 'NO CATEGORY';

export const TOOLTIP_CARD_SX = {
  bgcolor: 'background.paper',
  color: 'text.primary',
  boxShadow: 4,
  maxWidth: 320,
  p: 1.5,
  borderRadius: 1,
  '& .MuiTooltip-arrow::before': {
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider'
  }
};

export const autocompleteHelp = (
  <Stack gap={1.5} py={0.5}>
    <Typography variant="body2">
      Click here to add a label to this post.
    </Typography>
    <Typography variant="body2">
      You can also start typing to find existing labels and categories in your
      workspace.
    </Typography>
    <Typography variant="body2">
      If you want to add a label that does not yet exist, use the format{' '}
      <Typography component="span" variant="body2" fontWeight={700}>
        Category / Label
      </Typography>{' '}
      to create a new label and assign it to a category. If the category is new
      too, it will be created as well.
    </Typography>
    <Typography variant="body2">
      Hit the{' '}
      <Typography component="span" variant="body2" fontWeight={700}>
        Save Changes
      </Typography>{' '}
      button to finish adding and removing labels.
    </Typography>
  </Stack>
);
